import * as React from "react";
import { useIntl } from "react-intl";

import * as DTO from "../../../interfaces";
import { printOnlyDate } from "../../../utils";

import { descriptors, PromptsType } from "./descriptors";

import { ThumbnailPreview } from "./styled";
import "./styles.scss";
import { Card, Checkbox } from "semantic-ui-react";

interface OwnProps {
  prompt: DTO.Prompt;
  selected?: boolean;
  editable: boolean;
  onChange?: (checked: boolean) => void;
}

type Props = OwnProps;

const PromptSelectableCardFC: React.FC<Props> = ({
  prompt: { title, creationDate, post },
  selected = false,
  editable = true,

  onChange,
}: Props) => {
  const [thumbnail, setThumbnail] = React.useState<string | undefined>();
  const [isSelected, setIsSelected] = React.useState<boolean>(selected);
  const { formatMessage } = useIntl();

  React.useEffect(() => {
    setIsSelected(selected);
  }, [selected]);

  React.useEffect(() => {
    const uri = post?.media[0]?.thumbnailUri || post?.media[0]?.uri;
    setThumbnail(uri);
  }, [post]);

  return (
    <Card
      className={isSelected ? "promptSelectableCard cardSelected" : "promptSelectableCard"}
      selected={isSelected}
      onClick={() => {
        if (editable && onChange) {
          setIsSelected(!isSelected);
          onChange(!isSelected);
        }
      }}
    >
      <ThumbnailPreview width={3} thumbnailurl={thumbnail} />

      {editable && onChange && (
        <Checkbox
          className={"selectablePromptCheckbox"}
          radio
          checked={isSelected}
          onClick={() => {
            setIsSelected(!isSelected);
            onChange!(!isSelected);
          }}
        />
      )}
      <Card.Content>
        <Card.Header className={"selectablePromptTitle"}>{title}</Card.Header>
        <Card.Description>
          {formatMessage({ ...descriptors[PromptsType.createdTitle] }) + printOnlyDate(creationDate!!)}
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

export const PromptSelectableCard = PromptSelectableCardFC;
